import { Button } from "reactstrap";
import PropTypes from "prop-types";
import useUser from "../../../../../core/hooks/use-user";
import "./boton-acciones-cuadro-turnos.css";

const ESTILOS_BOTONES = {
    padding: "1px",
    borderRadius: "50%",
    textAlign: "center",
    fontSize: "10px",
    width: "20px",
    height: "20px",
};

const BotonAccionesCuadroTurnos = ({ onEmpleadoAccion, personaId }) => {
    const { userCan } = useUser();

    const onClick = () => {
        const botonPulsado = document.getElementById(
            `botones-acciones-${personaId}`
        );
        const botonEstaActivo = botonPulsado.classList.contains("activo");

        const botonesAccion = document.querySelectorAll(
            ".botones-acciones.activo"
        );
        botonesAccion.forEach((botonAccion) =>
            botonAccion.classList.remove("activo")
        );

        if (!botonEstaActivo) {
            botonPulsado.classList.add("activo");
        }
    };

    return (
        <>
            <div style={{ position: "relative" }}>
                <Button size="sm" style={ESTILOS_BOTONES} onClick={onClick}>
                    <i className="fas fa-cog" title="Acciones"></i>
                </Button>
                <div
                    id={`botones-acciones-${personaId}`}
                    className={`bg-white botones-acciones`}
                >
                    {userCan("nominaCopiarCuadroTurno") && (
                        <Button
                            key={`copiar-turno-${personaId}`}
                            size="sm"
                            style={ESTILOS_BOTONES}
                            color="secondary"
                            onClick={() =>
                                onEmpleadoAccion(personaId, "copiar")
                            }
                        >
                            <i
                                className="fas fa-copy"
                                title="Copiar cuadro de turnos"
                            ></i>
                        </Button>
                    )}
                    {userCan("editarAsignacionDeSubAreas") && (
                        <Button
                            key={`cambiar-subarea-${personaId}`}
                            size="sm"
                            style={ESTILOS_BOTONES}
                            color="primary"
                            className="m-2"
                            onClick={() =>
                                onEmpleadoAccion(personaId, "cambioArea")
                            }
                        >
                            <i
                                className="fas fa-redo"
                                title="Cambiar Subarea"
                            ></i>
                        </Button>
                    )}
                    {userCan("eliminarCuadroTurnoPorPersona") && (
                        <Button
                            key={`eliminar-turnos-${personaId}`}
                            size="sm"
                            style={ESTILOS_BOTONES}
                            color="danger"
                            onClick={() =>
                                onEmpleadoAccion(personaId, "eliminarTurnos")
                            }
                        >
                            <i
                                className="fas fa-times-circle"
                                title="Eliminar Turnos Colaborador"
                            ></i>
                        </Button>
                    )}
                    {userCan("personasInactivar") && (
                        <Button
                            key={`inactivar-colaborador-${personaId}`}
                            size="sm"
                            color="warning"
                            className="m-2"
                            style={ESTILOS_BOTONES}
                            onClick={() =>
                                onEmpleadoAccion(personaId, "personasInactivar")
                            }
                        >
                            <i
                                className="fas fa-user-slash"
                                title="Inactivar Colaborador"
                            ></i>
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

BotonAccionesCuadroTurnos.propTypes = {
    onEmpleadoAccion: PropTypes.func,
    personaId: PropTypes.number,
};

export default BotonAccionesCuadroTurnos;
